import { render, staticRenderFns } from "./SkillDevelopment.vue?vue&type=template&id=450510ac&"
import script from "./SkillDevelopment.vue?vue&type=script&lang=js&"
export * from "./SkillDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports